export const title = "Welcome to ShopeePay";
export const bodyText = "ShopeePay is SeaMoney’s mobile wallet, which provides users with easy access to digital payment services. Our mobile wallet offers users a seamless shopping experience."